<div
     class="d-flex h-100"
     container="body"
     [adaptivePosition]="adaptivePosition"
     [placement]="position"
     [containerClass]="(error ? 'error' : warning ? 'warning' : '') + ' ' + (compact ? 'popover-compact' : '')"
     [triggers]="delay ? '' : 'hover'"
     [popover]="delay ? '' : (text | translate: { value: textParam })"
>
    <ng-content select="[icon]"></ng-content>
</div>
